/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ListedTransitionReason = {
    caseId?: string;
    fromStatus?: ListedTransitionReason.fromStatus;
    toStatus?: ListedTransitionReason.toStatus;
    transitionTime?: string;
    transitionByName?: string;
    transitionById?: string;
    reason?: string;
};
export namespace ListedTransitionReason {
    export enum fromStatus {
        PENDING = 'PENDING',
        APPROVED = 'APPROVED',
        ARCHIVED = 'ARCHIVED',
        REJECTED = 'REJECTED',
        CLOSED = 'CLOSED',
    }
    export enum toStatus {
        PENDING = 'PENDING',
        APPROVED = 'APPROVED',
        ARCHIVED = 'ARCHIVED',
        REJECTED = 'REJECTED',
        CLOSED = 'CLOSED',
    }
}

